import { API_BASE_URL } from "@shared/config";

export const apiUrl = (path: string) =>
  `${API_BASE_URL}/${path.replace(/^\//, "")}`;
